<mat-card fxLayout="column" fxFlex="100%" [ngStyle]="{
    'border': '1px solid #e0e0e0',
    'padding': '16px 24px'}">
    <mat-spinner *ngIf="totalDifficultPSets?.length ==0 && !isMessage" diameter="20" ngClass="loader"></mat-spinner>
    <!--
    <span fxLayout="row" [ngClass]="['title-sm']" fxLayoutAlign="center center" fxFlex="100%" *ngIf="isMessage"
        style="position: absolute; margin-top: 2%; margin-bottom: 5%; margin-left: 37%">
        No Lessons
    </span>
-->

    <div fxLayout="row" fxLayoutAlign="space-between center">
        <article>
            <h4 class="chart-two-heading">All Lessons</h4>
        </article>

        <nav class="nv_rt rpd">
            <div style="float: left;" fxLayout="row">
                <div fxLayout="column">
                    <i class="fa fa-share-square-o" aria-hidden="true"
                        style="font-size: 24px; color:#707070; cursor: pointer;" *ngIf="!isMessage"
                        (click)="exportCsvData('performance')"></i>
                </div>
            </div>
        </nav>
    </div>

    <div *ngIf="isMessage" style="margin-top: 35px;margin-bottom: 35px;">
        <span fxLayout="row" class="title-sm" fxLayoutAlign="center center" fxFlex="100%">
            No Lessons
        </span>
    </div>

    <mat-card-content fxLayout="column" fxFlex="100%" fxLayoutAlign="center center">
        <div fxLayout="column" fxFlex="100%" [fxHide]="totalDifficultPSets ? totalDifficultPSets?.length == 0 : true">
            <div class="table-scroll-container">
                <table mat-table [dataSource]="dataSource" matSort matSortActive="averageCorrectAnswers"
                    matSortDirection="asc" class="mat-elevation-z8 ovrflw" aria-label="Average Correct Answers list">
                    <ng-container matColumnDef="lessonName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col" class="col-lesson">
                            Lesson Name
                        </th>
                        <td mat-cell *matCellDef="let element" class="brk_txt col-lesson"
                            [matTooltip]="element.lessonName" (click)="openPracSetAnalyticsView(element)" pointer>
                            {{element.lessonName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totalSession">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col" class="col-total">
                            Total Sessions
                        </th>
                        <td mat-cell *matCellDef="let element" class="tabel-element-width text-center col-total">
                            {{element.totalSession | number:'1.0':'en-US'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="averageDuration">
                        <th mat-header-cell *matHeaderCellDef scope="col" class="col-average">
                            Average Duration
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-center col-average">
                            {{element.averageDuration}}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <mat-paginator class="analytic-paginator" fxLayout="row" fxFlex="15%" fxLayoutAlign="space-between center"
                [pageSize]="5" [length]="totalDifficultPSets?.length" [style.display]="isPage?'none':''"
                [pageSizeOptions]="[5, 10, 25, 100]">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>